import { AUTH_TOKEN, AUTHENTICATED } from "../constants/Auth";

const initState = {
  token: localStorage.getItem(AUTH_TOKEN),
  user: 0,
  userObject: {},
};

const auth = (state = initState, action) => {
  switch (action.type) {
    case AUTHENTICATED:
      return {
        ...state,
        token: action.token,
        user: action.token,
        userObject: action.payload,
      };
    default:
      return state;
  }
};

export default auth;
